import { CreateArchiveSpecification } from '@wix/media-platform-js-client/dist/mjs/src/platform/management/job/create-archive-specification';
import { IDestination } from '@wix/media-platform-js-client/dist/mjs/src/platform/management/job/destination';
import { Job } from '@wix/media-platform-js-client/dist/mjs/src/platform/management/job/job';

import { ACL, Project } from '../../types/entities';
import { mediaPlatformProvider } from '../media-platform-provider';

export const DEFAULT_ARCHIVE_TYPE = 'zip';
export const DEFAULT_ARCHIVE_ACL = ACL.PUBLIC;

export const createArchive = (
  organizationId: string,
  project: Project,
  destination: IDestination,
  fileIdsList: string[],
): Promise<Job<CreateArchiveSpecification>> => {
  const archiveManager = mediaPlatformProvider.getSDKInstance(
    organizationId,
    project,
  ).archiveManager;
  const sources = fileIdsList.map((id) => ({ fileId: id }));

  return archiveManager.createArchive({
    destination,
    sources,
    archiveType: DEFAULT_ARCHIVE_TYPE,
  });
};
